import { combineReducers } from 'redux'
import teacherGuideReducer from 'app/store/reducers/teacher-guide/teacher-guide.reducer'

const TeacherGuideReducer = combineReducers({ ...teacherGuideReducer })

export default TeacherGuideReducer
